import { useEvents, useQuery, useSession } from 'common/hooks';
import { getGroupsApi } from '../profiles.service';
import { UseQueryOptions } from 'common/types/Api.type';
import { settled } from 'common/types/Event-type.type';

export const useGetProfileGroups = (profileId: string, options: UseQueryOptions = {}) => {
  const queryKey = ['profile', profileId, 'groups'];
  const queryResponse = useQuery(queryKey, () => getGroupsApi(profileId), {
    select: (data) => {
      if (data) {
        return data.data.groups;
      }
      return [];
    },
    ...options,
  });

  useEvents(settled('ProfileGroupsModified'), () => queryResponse.refetch());

  return {
    ...queryResponse,
  };
};
